import "whatwg-fetch";
import React from "react";
import Recaptcha from "react-google-recaptcha";
import cx from "classnames";
import browserOptimize from "../util/browserOptimize";
import Icon from "../components/Icon";
import Block from "../components/Blocks";
import { BackBanner } from "../components/Banners";
import Meta from "../components/Meta";

class ContactUs extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleChange - this.handleChange.bind(this);
    this.verify = this.verify.bind(this);

    this.state = {
      message: null,
      errors: {},
      responseType: null,
      isOpen: false,
      value: "What can we help you with?"
    };
  }

  verify(e) {
    e.preventDefault();
    this.recaptcha.execute();
  }

  handleSubmit() {
    const form = new FormData(this.form);

    this.setState(state => ({
      ...state,
      errors: {}
    }));

    const formEntries = browserOptimize(form, this.form);

    let valid = true;
    const errors = {};
    formEntries.forEach(([key, value]) => {
      if (key !== "bot-field") {
        if (key == "name")
          if (!value.trim().length) {
            errors[key] = true;
            valid = false;
          }
        if (key === "email") {
          const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const test = regEx.test(value);
          if (!test) {
            errors[key] = true;
            valid = false;
          }
        }
        if (key == "message")
          if (!value.trim().length) {
            errors[key] = true;
            valid = false;
          }
      }
    });

    if (!valid) {
      this.recaptcha.reset();
      this.setState(state => ({
        ...state,
        errors,
        message: "Please fill out all required fields."
      }));
      return;
    }

    fetch(this.form.getAttribute("action"), {
      method: "POST",
      body: form
    }).then(response => {
      if (response.status >= 400) {
        this.setState(() => ({
          message: "There was a problem with your submission.",
          responseType: "error"
        }));
      }
      this.setState(() => ({
        message: "Thank you for your message!",
        responseType: "success"
      }));
      this.form.reset();
      this.recaptcha.reset();
    });
  }

  toggleDropdown() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleChange(e) {
    this.setState({ value: e.target.innerText });
  }

  render() {
    const { errors, responseType, message, isOpen, value } = this.state;
    const { data } = this.props;
    const page = data.mortyPage;

    return (
      <div className="flex flex-column items-center mb3 mb4-l">
        <Meta page={page} />
        <BackBanner page={page} />
        <div className="mw-696 mh2">
          {message && (
            <p
              className={cx("form__message flex items-center ph1 mb1 p white bg-forest", {
                "bg-brick": Object.keys(errors).length > 0
              })}
            >
              {" "}
              {message}
            </p>
          )}
          <form
            data-netlify
            data-netlify-recaptcha
            data-netlify-honeypot="bot-field"
            method="POST"
            action="/"
            id="contact-form"
            name="contact"
            className="mb2 mb3-l"
            ref={f => {
              this.form = f;
            }}
            onSubmit={this.verify}
          >
            <input type="hidden" name="form-name" value="contact" />
            <span className="dn">
              <input name="bot-field" />
            </span>

            <input
              className={cx("form__input mb1 w-100 p", {
                "form__error--text": errors.name
              })}
              name="name"
              placeholder="Name"
              aria-labelledby="Name"
            />

            <input
              className={cx("form__input mb1 w-100 p", {
                "form__error--text": errors.email
              })}
              name="email"
              placeholder="Email Address"
              aria-labelledby="Email Address"
            />

            <input
              className="form__input mb1 w-100 p"
              name="phone"
              placeholder="Phone Number (optional)"
              aria-labelledby="Phone Number"
            />

            <input type="hidden" name="contact-reason" value={this.state.value} />
            <div
              className="form__select mb1 w-100 relative p"
              name="contact-reason"
              placeholder="contact-reason"
              value={this.state.value}
              onClick={() => {
                this.toggleDropdown();
              }}
            >
              <div
                className={cx("form__select__placeholder flex items-center grey2 relative", {
                  "o-50": this.state.value === "What can we help you with?"
                })}
              >
                {this.state.value}
              </div>
              <div className="form__select__arrow bg-stone absolute right-0 z-2 o-100 flex justify-center">
                <Icon path="arrow-down" />
              </div>
              <ul className={cx("absolute list z-2 pointer", { hidden: !isOpen })}>
                <li
                  className="flex items-center"
                  value="event"
                  label="I have a question about an event"
                  onClick={e => {
                    this.handleChange(e);
                  }}
                >
                  I have a question about an event
                </li>
                <li
                  className="flex items-center"
                  value="downtown"
                  label="I have a question about downtown"
                  onClick={e => {
                    this.handleChange(e);
                  }}
                >
                  I have a question about downtown
                </li>
                <li
                  className="flex items-center"
                  value="other"
                  label="other"
                  onClick={e => {
                    this.handleChange(e);
                  }}
                >
                  Other
                </li>
              </ul>
            </div>

            <textarea
              className={cx("form__textarea w-100 p", {
                "form__error--text": errors.message
              })}
              name="message"
              placeholder="Tell us more..."
              aria-labelledby="Message"
              maxLength="500"
              rows="6"
              style={{ resize: "none" }}
            />

            <div>
              <Recaptcha
                ref={e => {
                  this.recaptcha = e;
                }}
                sitekey="6LfP1VcUAAAAAC_hGC5qSWnD1db4NMKogKkK1fvL"
                onChange={this.handleSubmit}
                size="invisible"
              />
            </div>

            <button
              className="form__button bg-blue bg-ease-out b--none h-5 white w-100 ttu mt2 mt3-l"
              aria-labelledby="Submit"
            >
              Submit
            </button>
          </form>
          <div className="contact-form__address">
            <p className="p-bold mb0 dark">Venture Richmond</p>
            <p className="p mb0 grey2">200 S 3rd St</p>
            <p className="p mb0 grey2">Richmond, VA 23219</p>
            <p className="p mb0 grey2">
              (
              <a
                href="https://www.google.com/maps/place/Venture+Richmond/@37.539644,-77.4459797,17z/data=!3m1!4b1!4m5!3m4!1s0x89b1113e31a36161:0xb70f47780cdc70ce!8m2!3d37.539644!4d-77.4437924"
                target="_blank"
              >
                Directions
              </a>
              )
            </p>
            <p className="p mb0 grey2">
              Phone: <a href="tel:8047886466">(804)788-6466</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactUs;

export const pageQuery = graphql`
  query ContactUs($id: String!) {
    mortyPage(id: { eq: $id }) {
      route
      title
      subtitle
      abstract
      section
      metaTitle
      metaDescription
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      route
    }
  }
`;

export const previewQuery = `
  query ContactUs($id: String!) {
    mortyPage(id: { eq: $id }) {
      route
      title
      subtitle
      abstract
      section
      metaTitle
      metaDescription
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      route
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Contact-Us.js